export default __webpack_public_path__ + "static/media/gongan.0c577066.png";